import { createSlice } from '@reduxjs/toolkit';

// Redux states initialization
const initialState = {
 pageIndex:0
};

// Action functions declaration
export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    setPageIndex: (state, actions) => {
      state.pageIndex = actions.payload;
    },
    cleanupInitialState: () => initialState
  }
});

// Action creators are generated for each case reducer function
export const {
  setPageIndex,
  cleanupInitialState,
} = counterSlice.actions;

export default counterSlice.reducer;
